export default __webpack_public_path__ + "static/media/bookmark.b2999c82.svg";